import AuthService from "../../services/AuthService";
import BaseService from "../../services/BaseService";
import router from "../../router";

export default {
    state: {
        user: null
    },
    getters: {
        isAuthenticated(state) {
            return state.user != null;
        }
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user;
        }
    },
    actions: {
        login({ commit, dispatch }, data) {
            return AuthService.login(data).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    var user = result.data.data;
                    BaseService.clearHeaders();
                    commit('SET_USER', user);
                    commit('SET_ACCOUNTS', []);
                    commit('SET_PROJECTS', []);
                    commit('SET_USERS', []);

                    localStorage.setItem('user', JSON.stringify(user));
                    localStorage.setItem('user-logged', JSON.stringify(new Date()));

                    dispatch('loadProjects');
                    dispatch('loadAccounts');
                    dispatch('loadTransactionCategories');

                    router.push({ name: 'dashboard'});
                }
            });
        },
        register({ dispatch }, data) {
            return AuthService.register(data).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    data['_recaptcha'] = data.login_token;
                    dispatch('login', data);
                }
            });
        },
        logout({ commit }) {
            BaseService.clearHeaders();
            commit('SET_USER', null);
            commit('SET_ACCOUNTS', []);
            commit('SET_PROJECTS', []);
            commit('SET_USERS', []);

            localStorage.removeItem('user');
            localStorage.removeItem('user-logged');
        },
    },
}